import React from 'react';

const DetailSection = React.memo(({ title, children, icon }) => {
  const IconComponent = typeof icon === 'function' || (icon && typeof icon === 'object' && icon.$$typeof) ? icon : null;
  const isEmoji = typeof icon === 'string';

  return (
    <div className='mb-6'>
      <div className='flex items-center space-x-2 mb-4'>
        {IconComponent ? (
          <IconComponent className='w-5 h-5 text-slate-600' />
        ) : isEmoji ? (
          <span className='text-lg'>{icon}</span>
        ) : null}
        {typeof title === 'string' ? (
          <h3 className='text-lg font-semibold text-slate-800'>{title}</h3>
        ) : (
          <div className='text-lg font-semibold text-slate-800 w-full'>{title}</div>
        )}
      </div>
      {children}
    </div>
  );
});

export default DetailSection;
